import { useNavigate } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { FileUploaderSettingsDocument } from 'generated/resources/graphql'

import ExpiredTrialChecker from 'modules/core/components/ExpiredTrialChecker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import filesStore from 'modules/documents/components/Documents/store'
import UploadFormWizard from 'modules/documents/components/UploadFormWizard'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
  folder?: Folder
  backRoute: string
}

const NewDocument = ({ employee, folder, backRoute }: Props) => {
  const navigate = useNavigate()
  const {
    company: { subscription, id: companyId },
  } = useCurrentSession()
  const { data, loading } = useQuery(FileUploaderSettingsDocument, {
    variables: {
      companyId: companyId,
      employeeId: employee.id,
      space: SPACES.EMPLOYEE_MY_DOCUMENTS,
    },
  })

  const folders = data?.documents.folders || []
  const editableEmployeeFoldersRaw = data?.documents.editableEmployeeFolders || []
  const targetEmployee = data?.employees.employeesConnection.nodes[0]
  const legalEntity = data?.companies.legalEntitiesConnection.nodes[0]
  const canUseCompanyDocuments = data?.documents._policies?.companyUseCompanyDocuments.can
  const featureFlag = data?.features.featuresConnection.nodes[0]

  const manageableFolders = featureFlag?.enabled ? editableEmployeeFoldersRaw : folders
  const onClose = () => {
    filesStore.setFiles([])
    navigate(backRoute)
  }

  if (loading)
    return (
      <Box padding="s32" width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <ExpiredTrialChecker subscription={subscription} onClose={onClose}>
      <UploadFormWizard
        space={SPACES.EMPLOYEE_MY_DOCUMENTS}
        legalEntity={legalEntity}
        targetEmployee={targetEmployee}
        folders={manageableFolders}
        selectedFolder={folder}
        onClose={onClose}
        canUseCompanyDocuments={canUseCompanyDocuments}
      />
    </ExpiredTrialChecker>
  )
}

export default NewDocument
